import { Outlet } from "react-router-dom";

export const AdminApplicationContainer : React.FC = () => {

    return (
        <Outlet></Outlet>
    );
}
